import { defineMessages } from "react-intl";

import { node as albumin } from "src/modules/htx/forms/lab-procedures/albumin";
import { node as alkalinePhosphatase } from "src/modules/htx/forms/lab-procedures/alkalinePhosphatase";
import { node as bilirubinDirect } from "src/modules/htx/forms/lab-procedures/bilirubinDirect";
import { node as bilirubinTotal } from "src/modules/htx/forms/lab-procedures/bilirubinTotal";
import { node as bnp } from "src/modules/htx/forms/lab-procedures/bnp";
import { node as coombsDirect } from "src/modules/htx/forms/lab-procedures/coombsDirect";
import { node as coombsIndirect } from "src/modules/htx/forms/lab-procedures/coombsIndirect";
import { node as creatinine } from "src/modules/htx/forms/lab-procedures/creatinine";
import { node as crp } from "src/modules/htx/forms/lab-procedures/crp";
import { node as fvs } from "src/modules/htx/forms/lab-procedures/fvs";
import { node as gfr } from "src/modules/htx/forms/lab-procedures/gfr";
import { node as ggt } from "src/modules/htx/forms/lab-procedures/ggt";
import { node as got } from "src/modules/htx/forms/lab-procedures/got";
import { node as gpt } from "src/modules/htx/forms/lab-procedures/gpt";
import { node as haemoglobin } from "src/modules/htx/forms/lab-procedures/haemoglobin";
import { node as hgbA1C } from "src/modules/htx/forms/lab-procedures/hgbA1C";
import { node as inr } from "src/modules/htx/forms/lab-procedures/inr";
import { node as karbamid } from "src/modules/htx/forms/lab-procedures/karbamid";
import { node as ldh } from "src/modules/htx/forms/lab-procedures/ldh";
import { node as natrium } from "src/modules/htx/forms/lab-procedures/natrium";
import { node as ntProBNP } from "src/modules/htx/forms/lab-procedures/ntProBnp";
import { node as plateletCount } from "src/modules/htx/forms/lab-procedures/plateletCount";
import { node as potassium } from "src/modules/htx/forms/lab-procedures/potassium";
import { node as prealbumin } from "src/modules/htx/forms/lab-procedures/prealbumin";
import { node as psa } from "src/modules/htx/forms/lab-procedures/psa";
import { node as pseudocholinesterase } from "src/modules/htx/forms/lab-procedures/pseudocholinesterase";
import { node as serumGlucose } from "src/modules/htx/forms/lab-procedures/serumGlucose";
import { node as t3 } from "src/modules/htx/forms/lab-procedures/t3";
import { node as t4 } from "src/modules/htx/forms/lab-procedures/t4";
import { node as tsh } from "src/modules/htx/forms/lab-procedures/tsh";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.lab_procedures",
		defaultMessage: "Laborvizsgálatok"
	}
});

export const node: ParentNode = {
	id: "labProcedures",
	value: { type: "list", title: messages.title, columns: 2 },
	children: [
		fvs,
		haemoglobin,
		plateletCount,
		gfr,
		creatinine,
		karbamid,
		natrium,
		potassium,
		got,
		gpt,
		ggt,
		alkalinePhosphatase,
		inr,
		prealbumin,
		pseudocholinesterase,
		bilirubinTotal,
		bilirubinDirect,
		ldh,
		serumGlucose,
		hgbA1C,
		crp,
		tsh,
		t3,
		t4,
		albumin,
		bnp,
		ntProBNP,
		coombsDirect,
		coombsIndirect,
		psa
	]
};
